/**
 * SYM-5916. Which colour a NEW ad variant starts with.
 *
 * The ad builder took its colours from the LOGO: it downloaded the image, extracted the two most
 * dominant colours and wrote those onto the variant, falling back to two hardcoded greys when the
 * result was too pale to read. The customer's brand colours were never consulted.
 *
 * That is not a small miss. Measured on the production replica, 2,498 variants carry those exact
 * hardcoded greys while their brand HAS a colour set: ENGIE #00aaff renders #292524, Equans
 * #2abd93 renders #292524, DreamLand #51619c renders #44403C. Our own brand is purple and our own
 * ads were dark grey.
 *
 * Mark approved the rule on 2026-08-10: take the brand's colour when the brand has one, fall back
 * to the logo derivation when it does not. That serves both populations -- a customer who
 * configured a house style finally sees it, and a customer with no brand setup keeps the
 * derivation that was built for them.
 *
 * FORWARD ONLY. Steven confirmed this the same day: an ad that already exists keeps the colours it
 * was created with, including published ones. Nothing here reads or rewrites an existing variant.
 * The tempting "while we are here, fix the 2,498" is precisely the change that would silently
 * restyle live ads.
 *
 * Lives here rather than inline in the wizard because the app has no component tests, and a colour
 * precedence rule is exactly the kind of thing that reads as obviously correct and is not.
 */
export const pickSeedColour = (
  brandColour: string | null | undefined,
  usableLogoColour: string | null | undefined,
  fallback: string
): string => {
  const brand = brandColour?.trim();
  if (brand) return brand;

  const logo = usableLogoColour?.trim();
  if (logo) return logo;

  return fallback;
};
